import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Descriptions,
  Select,
  Statistic,
  Button,
  Typography,
  Modal,
  Card,
  Spin,
  Form,
  Divider,
  Col,
  InputNumber,
  Collapse,
  Tooltip,
  Table,
  Space,
  Skeleton,
} from "antd";
import {
  SettingOutlined,
  FolderOpenOutlined,
  LeftOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import TopContent from "../../../../../../../components/layouts/TopContent";
import { BOM } from "../../../../../../../services/definedMethod";
import cnt from "../../../../../../../services/definedConstant";

import "../../../../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../../../../components/layouts/MainLayout";
import RecordStatus from "../../../../../../../components/RecordStatus";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../../../customer/customer.config";
import styles from "../../../../../../../assets/styles/styles";
import Notiflix from "notiflix";

const { Text, Title } = Typography;
const { Panel } = Collapse;

const GroupSavingsDetailJournalEntry = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();

  const { state } = useLocation();
  const [useForm] = Form.useForm();

  // const [accountDetails, setAccountDetails] = useState([]);
  const [journalEntryList, setJournalEntryList] = useState([]);
  const [transactionInfo, setTransactionInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // console.log(state);
    getDetailById();
  }, []);

  const getDetailById = () => {
    const params = {
      transactionDetails: true,
      transactionId: state.transactionId,
    };

    const url = `${apiConfig.JournalEntries}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        // setIsLoading(false);
      } else {
        const objDetail = res.pageItems;
        setTransactionInfo(objDetail[0]);

        let tempArray = [];

        objDetail.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            branch: element?.officeName ? element?.officeName : "-",
            transactionDate: element?.transactionDate
              ? BOM.FormatArrayDate(element?.transactionDate)
              : "-",
            transactionId: element?.transactionId
              ? element?.transactionId
              : "-",
            type: element?.glAccountType?.value
              ? element?.glAccountType?.value
              : "-",
            createdBy: element?.createdByUserName
              ? element?.createdByUserName
              : "-",
            account: element?.glAccountName
              ? `${element?.glAccountName} (${element?.glAccountCode})`
              : "-",
            transactionTag: element?.entryType?.value
              ? element?.entryType?.value === "DEBIT"
                ? "Dr"
                : element?.entryType?.value === "CREDIT"
                ? "Cr"
                : "-"
              : "-",
            debit:
              element?.entryType?.value?.toLowerCase() === "debit"
                ? element?.amount
                : "-",
            credit:
              element?.entryType?.value?.toLowerCase() === "credit"
                ? element?.amount
                : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              "-"
            ),
            amountToUse: element?.amount ? element?.amount : 0,
          });
        });

        setJournalEntryList(tempArray);

        setIsLoading(false);
      }
    });
  };

  const columns = [
    {
      title: "Entry ID",
      dataIndex: "id",
    },

    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Account",
      dataIndex: "account",
      sorter: (a, b) => a.account.localeCompare(b.account),
    },
    {
      title: "Debit",
      dataIndex: "debit",
    },
    {
      title: "Credit",
      dataIndex: "credit",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <DetailTransactions
            currentCustomerObj={state}
            userData={userData}
            transactionObj={record}
          />
        </>
      ),
    },
  ];

  const items = [
    {
      label: "Transaction Number",
      children: transactionInfo ? transactionInfo.transactionId : "-",
    },
    {
      label: "Office",
      children: transactionInfo ? transactionInfo.officeName : "-",
    },

    {
      label: "TransactionDate",
      children: transactionInfo
        ? BOM.DateTime(transactionInfo.transactionDate, "only-date")
        : "-",
    },
    {
      label: "CreatedBy",
      children: transactionInfo ? transactionInfo.createdByUserName : "-",
    },
    {
      label: "Created On",
      children: transactionInfo
        ? BOM.DateTime(transactionInfo.createdDate, "only-date")
        : "-",
    },
  ];

  function backOnClick() {
    navigate("/group-savings-journal-entries", { state: state });
  }

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailJournalEntry}
        pageItems={staticConfig.detailJournalEntryBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                //   width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={backOnClick}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          {/* <Row>
            <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.generalInfo}
            </Title>
          </Row>{" "}
          <Divider style={{ marginTop: 10 }} /> */}
          <Row>
            <Col span={24}>
              <Descriptions
                bordered
                column={{
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 2,
                  xl: 2,
                  xxl: 2,
                }}
                style={{ marginTop: 10, marginBottom: 20 }}
                items={items}
              />
            </Col>
          </Row>
          {/* <Row style={{ marginBottom: 30 }}> */}
          <Divider />
          <Table columns={columns} dataSource={journalEntryList} />
          {/* </Row> */}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupSavingsDetailJournalEntry);

const DetailTransactions = (props) => {
  const { currentCustomerObj, userData, transactionObj } = props;

  const { session } = userData;

  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [transactionsDetail, setTransactionsDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const showModal = () => {
    setInputField([
      {
        name: labelConfig.branch,
        value: transactionObj.branch ? transactionObj.branch : "-",
      },
      {
        name: labelConfig.entryId,
        value: transactionObj?.id ? transactionObj?.id : "-",
      },
      {
        name: labelConfig.transactionId,
        value: transactionObj?.transactionId
          ? transactionObj?.transactionId
          : "-",
      },
      {
        name: labelConfig.transactionDate,
        value: transactionObj.transactionDate
          ? BOM.DateTime(transactionObj.transactionDate, "only-date")
          : "-",
      },
      {
        name: labelConfig.type,
        value: transactionObj.type ? transactionObj.type : "-",
      },
      {
        name: labelConfig.account,
        value: transactionObj.glAccountName
          ? transactionObj.glAccountName
          : "-",
      },
      {
        name: labelConfig.debit,
        value: transactionObj.debit ? transactionObj.debit : "-",
      },
      {
        name: labelConfig.paymentDetail,
        value: transactionObj.paymentDetail
          ? transactionObj.paymentDetail
          : "-",
      },
      {
        name: labelConfig.paymentTypes,
        value: transactionObj.paymentType ? transactionObj.paymentType : "-",
      },
      {
        name: labelConfig.accounNumber,
        value: transactionObj.accounNumber ? transactionObj.accounNumber : "-",
      },
      {
        name: labelConfig.chequeNumber,
        value: transactionObj.chequeNumber ? transactionObj.chequeNumber : "-",
      },
      {
        name: labelConfig.routingCode,
        value: transactionObj.routingCode ? transactionObj.routingCode : "-",
      },
      {
        name: labelConfig.receiptNumber,
        value: transactionObj.receiptNumber
          ? transactionObj.receiptNumber
          : "-",
      },
      {
        name: labelConfig.bank,
        value: transactionObj.bank ? transactionObj.bank : "-",
      },
      {
        name: labelConfig.createdBy,
        value: transactionObj.createdBy ? transactionObj.createdBy : "-",
      },
      {
        name: labelConfig.createdOn,
        value: transactionObj.createdDate
          ? BOM.DateTime(transactionObj.createdDate, "only-date")
          : "-",
      },
    ]);
    setIsModalOpen(true);
    // console.log(transactionObj);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Tooltip title={`View Detail`}>
        <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Journal Entry Detail"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Form layout="vertical" form={useForm}>
            <Row>
              {inputField.map((item, index) => (
                // item?.type?.toLowerCase() === "general" &&
                <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={item.name}>
                    <Input
                      disabled
                      value={item.value}
                      className="of-bold-disable-input"
                    />
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};
